import * as React from "react";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";

import { AppShape, HurdleShape } from "@eave/shared/types/api";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import { HurdleStatus } from "../HurdleStatus";
import { Column, TRUSTable } from "../../shared/TRUSTable";

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

interface HurdleEditorProps {
  dispatch?: Function;
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

class DocmagicWarningsHurdleEditor extends React.Component<HurdleEditorProps, any> {
  constructor(props: HurdleEditorProps) {
    super(props);
    const { override } = props.hurdle;
    this.state = {
      status: override && override.status ? override.status : null,
    };
  }

  renderDocmagicWarnings() {
    const latest_disclosure: any = this.props.app.disclosures && this.props.app.disclosures[0];

    return (
      <TRUSTable
        data={latest_disclosure && latest_disclosure.received_warnings}
        className="table table-striped table-hover hurdles-editor__table"
      >
        <Column header="Status Code">{row => "Warning"}</Column>
        <Column header="Status Description" dataKey="status_description" />
      </TRUSTable>
    );
  }

  render() {
    const { app, hurdle, onHide } = this.props;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <h4>Docmagic Warnings:</h4>
        {this.renderDocmagicWarnings()}
        <h4>Override Status:</h4>
        <Select
          placeholder="override status"
          value={this.state.status}
          clearable={false}
          options={[
            {
              value: null,
              label: <span className="hurdles-editor__emdash">—</span>,
            },
            { value: "red", label: <HurdleStatus status="red" /> },
            { value: "yellow", label: <HurdleStatus status="yellow" /> },
            { value: "green", label: <HurdleStatus status="green" /> },
          ]}
          onChange={e => this.setState({ status: e.value })}
        />
        <br />
        <h4>Raw hurdle JSON:</h4>
        <pre>{JSON.stringify(hurdle, null, "\t")}</pre>

        <footer className={styles.footer}>
          <button type="button" onClick={() => onHide()}>
            Cancel
          </button>
        </footer>
      </HurdleView>
    );
  }
}

export default DocmagicWarningsHurdleEditor;
